import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
// Import logo directly as a module
import reactLogo from './logo.svg'; // Fallback logo only used if the main image fails

// Pages
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Error from './pages/Error';
import Callback from './pages/Callback';

// Auth context
import { AuthProvider, useAuth } from './context/AuthContext';

// Wallet Provider
import { WalletProvider } from './components/WalletProvider';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }
  
  return children;
};

function App() {
  
  const logoUrl = "https://i.ibb.co/W49Z31hV/logo.png";
  
  return (
    <AuthProvider>
      <WalletProvider>
        <Router>
          <div className="App">
            <div className="logo-container">
              <img 
                src={logoUrl}
                alt="Logo" 
                className="logo" 
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = reactLogo; 
                  console.log("Logo failed to load, using fallback");
                }}
              />
            </div>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route path="/callback" element={<Callback />} />
              <Route path="/error" element={<Error />} />
            </Routes>
          </div>
        </Router>
      </WalletProvider>
    </AuthProvider>
  );
}

export default App;
